/**
 * Formats date and time for event display
 * @param {string} start - Start date/time
 * @param {string} end - End date/time (optional)
 * @returns {string} Formatted date/time range
 */
export const formatEventDate = (start, end) => {
	if (!start) return "";
	try {
		const startDate = new Date(start);
		const dateStr = startDate.toLocaleDateString("de-DE", { year: "numeric", month: "numeric", day: "numeric" });
		const timeStr = startDate.toLocaleTimeString("de-DE", { hour: "numeric", minute: "numeric" });
		if (end) {
			const endDate = new Date(end);
			const endTimeStr = endDate.toLocaleTimeString("de-DE", { hour: "numeric", minute: "numeric" });
			return `${dateStr}, ${timeStr} - ${endTimeStr}`;
		}
		return `${dateStr}, ${timeStr}`;
	} catch {
		return start;
	}
};
